var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hamburger-icon"},[_c('label',{staticClass:"hamburg",class:{ 'icon--active': _vm.active }},[_c('span',{staticClass:"line"}),_c('span',{staticClass:"line"}),_c('span',{staticClass:"line"})])])}
var staticRenderFns = []

export { render, staticRenderFns }